import { AdminUserPermissionsEnum, VerificationTypesEnum } from '@/lib/enum.ts';
import { SecuredComponent } from '@/components/hoc';
import { useUserConnected } from '@/hooks';
import { Button } from '@/components/ui';
import { Link } from 'react-router-dom';
import { History } from 'lucide-react';
import routes from '@/lib/routes';
import { cn } from '@/lib/utils';

type TProps = {
	type: VerificationTypesEnum;
	className?: string;
	showIcon?: boolean;
};

const ButtonsShowHistory = ({ type, className, showIcon }: TProps) => {

	const { userConnected } = useUserConnected();

	return (
		<SecuredComponent permissionsRequired={[AdminUserPermissionsEnum.HISTORY]}>
			<Link to={routes.nav.verificationsHistory.getHref(type, { authorIds: [userConnected?._id!] })}>
				<Button
					variant={'link'}
					className={cn(
						'flex items-center space-x-1 text-purple-600 text-sm',
						className
					)}
					size={'sm'}>
					{
						showIcon &&
						<History size={16} />
					}
					<span>
						Afficher l'historique
					</span>
				</Button>
			</Link>
		</SecuredComponent>
	);

};

export default ButtonsShowHistory;
